import React from "react";

const localeFor = (language) => language === "ar" ? "ar-EG" : "en-US";

export const formatUserManagementDateTime = (value, language = "en") => {
  const parsed = new Date(value);
  if (!value || Number.isNaN(parsed.getTime())) return null;
  const locale = localeFor(language);
  const common = { timeZone: "Africa/Cairo" };
  return {
    date: new Intl.DateTimeFormat(locale, {
      ...common,
      year: "numeric",
      month: "short",
      day: "numeric"
    }).format(parsed),
    time: new Intl.DateTimeFormat(locale, {
      ...common,
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    }).format(parsed)
  };
};

const UserManagementDateTime = ({ value, language = "en" }) => {
  const formatted = formatUserManagementDateTime(value, language);
  if (!formatted) return <span className="user-management-date-empty">—</span>;
  return (
    <time className="user-management-date-time" dateTime={new Date(value).toISOString()}>
      <span data-testid="date-line">{formatted.date}</span>
      <span data-testid="time-line">{formatted.time}</span>
    </time>
  );
};

export default UserManagementDateTime;
